import { useIntl } from 'react-intl';
import useReactRouter from 'use-react-router';
import PATHS from '../../constants/paths';
import * as React from 'react';
import { ToastComponent } from '../ToastComponent';

export const FirstPageAnalysisBadge = (props: any) => {
  const intl = useIntl();
  const { history } = useReactRouter();

  const openInsights = () => {
    history.push(PATHS.STATISTICS.INDEX);
  };

  const messageBase = 'components.FirstAnalysisToast';

  return (
    <ToastComponent
      infoTitle={intl.formatMessage({
        id: `${messageBase}.title`,
      })}
      title={intl.formatMessage({
        id: `${messageBase}.subtitle`,
      })}
      description={intl.formatMessage({
        id: `${messageBase}.description`,
      })}
      iconName={'img-insights'}
      buttonTitle={intl.formatMessage({
        id: `${messageBase}.action`,
      })}
      onButtonClick={openInsights}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/FirstPageAnalysisBadge/index.tsx